import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFoundPage = () => {
  return (
    <>
      <SEO 
        title="404 - Page Not Found"
        description="The page you're looking for doesn't exist. Navigate back to GTO Preflop to master your poker strategy."
        schema={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "404 Error Page",
          "description": "Page not found"
        }}
      />
      <div style={{ textAlign: 'center', padding: '50px' }}>
        <h1>404 - Page Not Found</h1>
        <p>Sorry, the page you're looking for doesn't exist.</p>
        <Link to="/" style={{ color: '#2196F3' }}>Return to Homepage</Link>
      </div>
    </>
  );
};

export default NotFoundPage;